function pluginCsp() {
  const ctx = document;
  const getHost = (uri) => {
    try {
      return new URL(uri).host;
    } catch {
      return uri;
    }
  };
  const getDescriptiveHost = (uri) => getHost(uri) || '<undefined>';

  const cleanDirective = (directive) => directive.split(' ')[0];
  const sourcesByDirective = (originalPolicy) => Object.fromEntries(
    originalPolicy.split('; ').map((rule) => {
      const [directive, ...sources] = rule.split(' ');
      return [directive, sources.map((source) => getHost(source))];
    }),
  );
  const buildMessage = (directive, blockedHost, sources) => {
    const sourceListing = sources.map((source) => ` - ${source}`).join('\n');

    return `Violation of ${directive}. ${blockedHost} missing in:\n${sourceListing}`;
  };

  return function plugin() {
    const self = this;

    const onSecurityPolicyViolationHandler = (event) => {
      if (event.effectiveDirective !== undefined) {
        const span = self.createSpan();
        const blockedHost = getDescriptiveHost(event.blockedURI);
        const directive = cleanDirective(event.effectiveDirective);

        span.setError({
          name: 'SecurityPolicyViolationError',
          message: buildMessage(directive, blockedHost, sourcesByDirective(event.originalPolicy)[directive]),
        });

        span.setNamespace('csp');
        span.setAction(`${directive} ${blockedHost}`);
        span.setTags({
          csp_blocked_host: blockedHost,
          csp_blocked_uri: event.blockedURI || '<undefined>',
          csp_column_number: event.columnNumber || '<undefined>',
          csp_disposition: event.disposition || '<undefined>',
          csp_document_uri: event.documentURI || '<undefined>',
          csp_effective_directive: directive || '<undefined>',
          csp_line_number: event.lineNumber || '<undefined>',
          csp_referrer: event.referrer || '<undefined>',
          csp_sample: event.sample || '<undefined>',
          csp_source_file: event.sourceFile || '<undefined>',
          csp_status_code: event.statusCode || '<undefined>',
        });

        self.send(span);
      }
    };

    ctx.onsecuritypolicyviolation = onSecurityPolicyViolationHandler;
  };
}

export const plugin = pluginCsp;
